import { ServicePointServiceMock } from "./servicepoint.types";

export const mockServicePointService = (): ServicePointServiceMock => ({
  fetchServicePoints: jest.fn(),
  fetchServicePointsByGroupRules: jest.fn(),
  createServicePointV3: jest.fn(),
  updateServicePointV3: jest.fn(),
  changeStatus: jest.fn(),
  fetchServicePointTypes: jest.fn(),
});
